import React from "react"

import {
	Box,
	Button,
} from "@mui/material"
import {
	TabContext,
	TabPanel,
	Timeline,
	TimelineConnector,
	TimelineContent,
	TimelineDot,
	TimelineItem,
	timelineItemClasses,
	TimelineSeparator,
} from "@mui/lab"

import {
	t,
	Trans,
} from "@lingui/macro"
import Icon from "@mdi/react"
import {
	mdiCircle,
	mdiPlusBox,
} from "@mdi/js"

import {
	Action,
	ActionStatus,
	Workflow,
	WorkflowActionsResponse,
	WorkflowActionUtils,
	WorkflowStatus,
} from "models"
import {
	SbTab,
	SbTabList,
} from "components/commons"

import { WorkflowActions } from "../../detail/workflow-actions"


interface WorkflowColumnTwoProps {
	openAssignWorkflowActionDialog: (action: Action) => void
	openDeferActionDialog: (action: Action) => void
	openCreateActionDialog: () => void
	openEditActionDialog: () => void
	onActionSelected: (action: Action) => void
	markActionAsDone: (action: Action) => void
	skipAction: (actionId: string) => void
	selectedAction: Action | null
	workflowActions: WorkflowActionsResponse
	workflow: Workflow | null
}
interface WorkflowColumnTwoState {
}
export class WorkflowColumnTwo extends React.Component<WorkflowColumnTwoProps, WorkflowColumnTwoState> {
	private getIconColour = (data: Action): string => {
		switch (data.status) {
			case ActionStatus.PENDING:
			case ActionStatus.SKIPPED:
				return "lightgray"
			case ActionStatus.WORKING:
				let today = new Date()
				let deadline = new Date(data.deadline)
				today.setHours(0, 0, 0, 0)
				deadline.setHours(0, 0, 0, 0)
				if (deadline.getTime() < today.getTime()) {
					return "error.main"
				}
				return "secondary.main"
			case ActionStatus.DONE:
				return "primary.main"
		}
	}

	render() {
		return (
			<TabContext value="1">
				<Box sx={{ borderBottom: 0 }}>
					<SbTabList variant="fullWidth">
						<SbTab
							disableRipple
							disableTouchRipple
							label={t({ id: "workflow.workflow-actions", message: "Azioni in questo workflow", })}
							value="1" />
					</SbTabList>
				</Box>
				<TabPanel value="1" sx={{ px: 0 }}>
					<Box overflow={"auto"} height={"52vh"}>
						<Timeline
							sx={{
								py: 0,
								my: 0,
								[`& .${timelineItemClasses.root}:before`]: {
									flex: 0,
									padding: 0,
								},
							}}>
							{this.props.workflowActions.actions.map((data: Action) => (
								<TimelineItem key={data.id}>
									<TimelineSeparator>
										<TimelineDot sx={{ backgroundColor: this.getIconColour(data) }}>
											<Icon path={WorkflowActionUtils.renderIcon(data.actionType)} size={0.85} />
										</TimelineDot>
										<TimelineConnector sx={{ backgroundColor: "primary.main" }} />
									</TimelineSeparator>
									<TimelineContent sx={{ ml: 2, backgroundColor: this.props.selectedAction?.id === data.id ? "#eceff5" : "unset" }}>
										<WorkflowActions
											action={data}
											openAssignDialog={() => this.props.openAssignWorkflowActionDialog(data)}
											openDeferDialog={() => this.props.openDeferActionDialog(data)}
											onActionSelected={() => this.props.onActionSelected(data)}
											markActionAsDone={() => this.props.markActionAsDone(data)}
											skipAction={this.props.skipAction}
										/>
									</TimelineContent>
								</TimelineItem>
							))}
							{(this.props.workflow && this.props.workflow.status !== WorkflowStatus.DONE) && <TimelineItem>
								<TimelineSeparator>
									<TimelineDot sx={{ backgroundColor: "text.primary" }}>
										<Box component={Icon} path={mdiCircle} size={0.85} sx={{ color: "text.primary" }} />
									</TimelineDot>
								</TimelineSeparator>
								<TimelineContent>
									<Button
										startIcon={<Icon path={mdiPlusBox} size={1} />}
										variant="contained"
										color="secondary"
										size="small"
										sx={{ mt: 1 }}
										onClick={this.props.openCreateActionDialog}>
										<Trans id="workflow.add-new-action">
											Aggiungi nuova azione
										</Trans>
									</Button>
								</TimelineContent>
							</TimelineItem>}
						</Timeline>
					</Box>
				</TabPanel>
			</TabContext>
		)
	}
}
